import React from 'react';

const Stage5 = (props) => {
    return (
        <div>Stage 5</div>
    );
}

export default Stage5;